<template>
  <div class="mb-3" :style="[allStudentShow ? { maxHeight: 'none' } : { maxHeight: '133px' }, { overflow: 'hidden' }]" v-if="checkSelectedTag()">
    <K2Row :space-between="true" :styles="{ width: '100%' }">
      <K2Text bold="true">{{ lang('Showing To') }}</K2Text>
      <K2Button size="mini" v-if="allStudentShow" @onclick="handleStudentShow()">{{ lang('Show Less') }} </K2Button>
      <K2Button size="mini" v-else-if="selectedStudents && selectedStudents.length > 5" @onclick="handleStudentShow()">{{ lang('Show All') }} </K2Button>
    </K2Row>
    <K2Row class="flex-wrap" v-if="levelList && levelList.length > 0" :styles="{ flexWrap: 'wrap' }">
      <K2Row justify_content="center" align="center" v-for="(level, i) in levelList" :key="i" class="box blue me-2 mt-2 rounded-pill px-3 px-md-2 py-1">
        <K2Text color="white">{{ level.Str_Display || level.PostTagLevelName }}</K2Text>
      </K2Row>
    </K2Row>
    <K2Row v-else-if="classList && classList.length > 0" :styles="{ flexWrap: 'wrap' }">
      <K2Row justify_content="center" align="center" v-for="(classes, i) in classList" :key="i" class="box yellow me-2 mt-2 rounded-pill px-3 px-md-2 py-1">
        <K2Text>{{ classes.Str_Display || classes.PostTagClassName }} {{ classes.PostTagClassBatch }}</K2Text>
      </K2Row>
    </K2Row>
    <K2Row v-else-if="selectedStudents && selectedStudents.length > 0" :styles="{ flexWrap: 'wrap' }">
      <K2Row v-if="selectedStudents[0].CLS_ClassName">
        <K2Row v-for="studentClass in selectedStudents" :key="studentClass.CLS_ClassName" :styles="{ flexWrap: 'wrap' }">
          <K2Row v-if="selectedStudents[0].itemList" class="flex-wrap">
            <K2Row
              justify_content="center"
              align="center"
              v-for="(student, i) in studentClass.itemList"
              :key="student.PostTagUserID + i"
              class="box purple me-2 mt-2 rounded-pill px-3 px-md-2 py-1"
            >
              <K2Text :color="uiVariable.color.purple" class="me-2">{{ studentClass.CLS_ClassName }} : </K2Text>
              <K2Text :color="uiVariable.color.purple"> {{ student.StudentName || student.First_Name }} </K2Text>
            </K2Row>
          </K2Row>
          <K2Row
            justify_content="center"
            align="center"
            v-for="(student, i) in selectedStudents"
            v-else
            :key="student.PostTagUserID + i"
            class="box purple me-2 mt-2 rounded-pill px-3 px-md-2 py-1"
          >
            <K2Text :color="uiVariable.color.purple">{{ student.StudentName || student.First_Name }} </K2Text>
          </K2Row>
        </K2Row>
      </K2Row>
      <div v-else>
        <K2Row :styles="{ flexWrap: 'wrap' }">
          <K2Row
            justify_content="center"
            align="center"
            v-for="student in selectedStudents"
            :key="student.PostTagUserID"
            class="box purple me-2 mb-2 rounded-pill px-3 px-md-2 py-1"
          >
            <K2Text :color="uiVariable.color.purple" class="me-2">{{ student.StudentClassName }} : </K2Text>
            <K2Text :color="uiVariable.color.purple"> {{ student.StudentName || student.First_Name }} </K2Text>
          </K2Row>
        </K2Row>
      </div>
    </K2Row>
  </div>
</template>
<script>
import K2Row from '@/uiComponents/k2Row/k2Row'
import K2Text from '@/uiComponents/k2Text/k2Text'
import K2Button from '@/uiComponents/k2Button/k2Button'
import { lang } from '../../../../../locale'
import uiVariable from '@/config/uiVariable'

export default {
  name: 'NewPostPreviewTag',
  components: { K2Button, K2Text, K2Row },
  props: ['selectedStudents', 'levelList', 'classList'],
  data() {
    return {
      allStudentShow: false,
      uiVariable: uiVariable,
    }
  },
  methods: {
    lang,
    checkSelectedTag() {
      if (this.selectedStudents?.length > 0 || this.classList?.length > 0 || this.levelList?.length > 0) {
        return true
      }
    },
    handleStudentShow() {
      this.allStudentShow = !this.allStudentShow
    },
  },
}
</script>
